import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import PCDSnippetsManagementDashboard from "../../../components/GlobalContestsManagementDashboard/PCDSnippetsManagementDashboard";
import Navbar from "../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";
import { clamp } from "../../../utils/responsiveHelpers";

const PCDSnippetsManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.globalContests?.hasPcdSnippetsViewAccess) {
      navigate(LOGIN);
    }
  }, [navigate, userConfig]);

  return (
    <>
      <Navbar />
      <div style={{ padding: `0 ${clamp(12, 24)}` }}>
        <PCDSnippetsManagementDashboard userConfig={userConfig} ROOT_URL={ROOT_URL} />
      </div>
    </>
  );
};

export default PCDSnippetsManagement;
